
/**
 * 图片验证码
 * @example  <img v-verify />
 */
var verify={
    _listeners:[],
    _current:"",
    _change:function(){
       return this._current=this._url+Date.now();
    },
    on:function(img){
        var src=this._current||this._change();
        img.src=src;
        this._listeners.push(img);
        img.addEventListener("click",this,false);
    },
    off:function(img){
        var imgs=this._listeners,
        i=imgs.indexOf(img);
        if(i!==-1){
            imgs.splice(i,1);
        }
    },  
    handleEvent:function(){
        var imgs=this._listeners,
            i=imgs.length,
            current=this._change();

        while(i--){
            imgs[i].src=current;
        }
    },
    install(Vue,url){
        if(this.installed)return;        
        var _this=this;
        this.installed=true;
        this._url=url;

        Vue.directive("verify",{
            inserted(el){ 
                _this.on(el);
            },           
            unbind(el){
                _this.off(el);
            }
        });
    }
};

export default verify;


// WEBPACK FOOTER //
// ./src/plugins/verify/index.js